import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { Card, CardContent } from '@material-ui/core';

const useStyles = makeStyles({
  root: {
    minWidth: 275,
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  }
});


function Customer(props) {
    const classes = useStyles();

    return (
        <Card className={classes.root} variant="outlined">
        <CardContent>
          {
            props.customer.email
          }
        </CardContent>
      </Card>
      )
}

export default Customer
